module.exports = __webpack_public_path__ + "media/images/athletes/3407-145774dd34ab61f9f768b1cd613f233f.png";